module.exports = __webpack_public_path__ + "static/kuu-7a79fdea5872ea8aeecf1066fde94eb7.png";